<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NavigationInnerHead',

  props: {
    title: String,
    icon: String,
  },
});
</script>

<template>
  <q-avatar color="accent" class="text-white q-mr-sm" size="3rem" style="box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px">
    <q-icon name="arrow_right_alt" color="primary" size="md" />
  </q-avatar>
  <q-chip color="accent" class="text-subtitle1 text-weight-bold q-px-xl text-primary" style="box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px; padding: 1.2rem">
    <q-icon :name="icon" size="1.1rem" class="q-mr-sm" />
    <span class="text">{{ title }}</span>
  </q-chip>
</template>

<style scoped>
.text {
  letter-spacing: 0.06rem;
}
</style>
